import { defineComponent, ref } from '@vue/composition-api';
import Card from '@/components/Card/Card.vue';
import { Icon, IconSize } from '@/components/Icon';
import ArrowSvg from '@/assets/icons/arrow-down.svg';
export default defineComponent({
    name: 'ObjectsTreePlace',
    components: {
        Card,
        Icon,
    },
    props: {
        place: {
            type: Object,
            required: true,
        },
        defaultExpanded: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const isExpanded = ref(props.defaultExpanded);
        const togglePlace = () => {
            isExpanded.value = !isExpanded.value;
        };
        return {
            isExpanded,
            togglePlace,
            ArrowSvg,
            IconSize,
        };
    },
});
